module.exports = __webpack_public_path__ + "static/[UI]next-travel-s.1bd85e19.gif";


//////////////////
// WEBPACK FOOTER
// ./src/gallery/thumbs/[UI]next-travel-s.gif
// module id = 560
// module chunks = 27362984104999